import React from "react";

interface IntroWrapperProps {
  children: React.ReactNode;
}

export const IntroWrapper: React.FC<IntroWrapperProps> = ({ children }) => {
  return (
    <div
      style={{
        background:
          "linear-gradient(169deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.80) 22.33%, rgba(245, 240, 255, 0.80) 23.92%, rgba(255, 255, 255, 0.80) 28%, rgba(255, 255, 255, 0.80) 50.89%, rgba(245, 240, 255, 0.80) 56.96%, rgba(255, 255, 255, 0.80) 68.71%), #FFF",
      }}
    >
      {children}
    </div>
  );
};
